import React, { useContext, useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Modal, Spinner, Form, FormControl, Button, Card } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import downloadCSV from '../csv/downloadCSV';
import Select from 'react-select';
import consultaEstadoDocs from 'api/consultaEstadoDocs';
import { AccountContext } from 'components/Account/Account';
import consultaPorEstado from "api/consultaPorEstadoDocs";
import consultaEstado from 'api/consultaEstado';
import reenvioDocs from "api/reenvioDocs";

function EstadoResumen() {

  let today = new Date();
  let miliseconds = today.getTime() - 24 * 60 * 60 * 1000;//restar 2 días
  let yesterday = new Date(miliseconds);
  const [tipodocumento, setTipodocumento] = useState("39");
  const [startDate, setStartDate] = useState(new Date().toISOString().slice(0, 10));
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));
  const [loading, setLoading] = useState(true);
  const [loadingDetail, setLoadingDetail] = useState(true);
  const [filtered, setFiltered] = useState(null)//Filtro para eliminar elementos nulos y asignar solo atributos vistos en tabla
  const [filter, setFilter] = useState('');//value input
  const [dataFiltered, setDataFiltered] = useState(null);
  const [dataDocs, setDataDocs] = useState(null);//datos filtrados del input search
  const [Message, setMessage] = useState('');
  const [modalTitle, setmodalTitle] = useState('');

  const { user, getSession } = useContext(AccountContext);
  const [checked, setChecked] = useState(false);
  const [show, setShow] = useState(false);
  const [detailShow, setDetailShow] = useState(false);
  const [detailData, setDetailData] = useState(false);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [toggleCleared, setToggleCleared] = React.useState(false);

  const handleClose = () => {
    setShow(false)
  };
  const handleCloseDetail = () => {
    setDetailShow(false)
  };

  const cleanParams = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== '' && v !== null && v !== undefined)
    );
  const busqueda = async (e) => {
    e.preventDefault()


    setMessage('Cargando');
    setLoading(true);
    setmodalTitle('Consulta Estado Resumen')
    setShow(true);

    console.log('busqueda')

    const params = cleanParams({ startDate, endDate, tipodocumento });

    console.log('params', params);

    const idToken = await getSession().then((session) => { return session.idToken.jwtToken });
    // console.log(params,idToken);
    try {
      const resp = await consultaEstadoDocs(params, idToken);
      setFiltered(resp);

      setLoading(false);
      setShow(false);


    } catch (error) {
      console.log(error)
      setMessage('Error');
      setLoading(false);
    }




    //Consultar a Api por documento (folio,rutEmpresa)
  }

  const handleButtonClick = async (row, estado) => {

    let RUT = row.rut;

    setmodalTitle('Consulta Estado Resumen')
    setMessage('Cargando');
    setLoading(true);

    setShow(true);

    try {
      const idToken = await getSession().then((session) => { return session.idToken.jwtToken });
      const params = { estado, RUT, startDate, endDate, tipodocumento };
      const resp = await consultaPorEstado(params, idToken);
      console.log('resp', resp)
      setDetailData(resp)
    } catch (error) {
      console.log(error)
      setMessage('Error');
      setLoading(false);
    }
    setLoading(false);
    setShow(false);
    setDetailShow(true)



  };


  const handleChange = (e) => {
    console.log('handleChange')
    e.preventDefault();
    setFilter(e.target.value)
    const aux = filtered.filter(
      element => element.name.toLowerCase().trim().includes(e.target.value.toLowerCase().trim())

    )
    setDataFiltered(aux);

  }


  useEffect(() => {
    if (filtered == null) {
      setDataFiltered(null);
      return;
    }
    if (checked) {
      const aux = filtered.filter(
        element => element.documentos_no_autorizados > 0 ||
          element.no_recibidos > 0 ||
          element.nulos > 0 ||
          element.recibidos_con_errores > 0 ||
          element.documentos_reenviados > 0
      );
      setDataFiltered(aux);
    } else {
      setDataFiltered(filtered);
    }
  }, [checked, filtered])

  function getFirstDayOfMonth(year, month) {
    return new Date(year, month, 1);
  }

  useEffect(() => {
    // console.log(yesterday);

    const firstDayCurrentMonth = getFirstDayOfMonth(
      yesterday.getFullYear(),
      yesterday.getMonth(),
    );

    setStartDate(firstDayCurrentMonth.toISOString().slice(0, 10));
    setEndDate(yesterday.toISOString().slice(0, 10));
    // console.log(firstDayCurrentMonth);

  }, [])



  // useEffect(() => {
  //   // console.log(yesterday);
  //  console.log('dsadsdsa');

  // }, [ExpandedComponent])

  const stats = useMemo(() => {
    if (!filtered) return null;
    const toNum = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    };
    let problemas = 0;
    let noAutorizados = 0;
    let noRecibidosOEnviados = 0;
    let conErrores = 0;
    filtered.forEach((r) => {
      const na = toNum(r.documentos_no_autorizados);
      const nr = toNum(r.no_recibidos);
      const ne = toNum(r.nulos);
      const ce = toNum(r.recibidos_con_errores);
      noAutorizados += na;
      noRecibidosOEnviados += nr + ne;
      conErrores += ce;
      problemas += na + nr + ne + ce;
    });
    return { problemas, noAutorizados, noRecibidosOEnviados, conErrores };
  }, [filtered]);

  const countCell = (value, estado, row, variant = 'neutral') => {
    const n = value ?? 0;
    const clickable = n > 0;
    const cls = `count-cell count-cell--${clickable ? variant : 'zero'}`;
    return (
      <span
        className={cls}
        onClick={clickable ? () => handleButtonClick(row, estado) : undefined}
        role={clickable ? 'button' : undefined}
        title={clickable ? 'Ver detalle' : undefined}
      >
        {n}
      </span>
    );
  };

  const columns = [
    {
      name: 'Rut',
      selector: row => row.rut,
      sortable: true,
      width: '100px',
    },
    {
      name: 'Empresa',
      selector: row => row.name,
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Aceptados',
      selector: row => row.documentos_aceptados,
      cell: (row) => <span className="count-cell count-cell--success">{row.documentos_aceptados ?? 0}</span>,
      sortable: true,
      right: true,
      width: '110px',
    },
    {
      name: 'No autorizados',
      selector: row => row.documentos_no_autorizados ?? 0,
      cell: (row) => countCell(row.documentos_no_autorizados, 'No Autorizado', row, 'danger'),
      sortable: true,
      right: true,
      width: '130px',
    },
    {
      name: 'No recibidos',
      selector: row => row.no_recibidos ?? 0,
      cell: (row) => countCell(row.no_recibidos, 'No recibido', row, 'danger'),
      sortable: true,
      right: true,
      width: '120px',
    },
    {
      name: 'No enviados',
      selector: row => row.nulos ?? 0,
      cell: (row) => countCell(row.nulos, 'isNull', row, 'warning'),
      sortable: true,
      right: true,
      width: '120px',
    },
    {
      name: 'Con errores',
      selector: row => row.recibidos_con_errores ?? 0,
      cell: (row) => countCell(row.recibidos_con_errores, 'Recibido con errores', row, 'danger'),
      sortable: true,
      right: true,
      width: '120px',
    },
    {
      name: 'Reenviados',
      selector: row => row.documentos_reenviados ?? 0,
      cell: (row) => countCell(row.documentos_reenviados, 'Reenviado', row, 'info'),
      sortable: true,
      right: true,
      width: '120px',
    },
  ];



  const ExpandedComponent = ({ data }) => {
    // const [detailDocs, setdetailDocs] = useState(null);
    const [siiData, setSiiData] = useState(null);

    const respPorDocumento = async (data) => {
      const { rut, folio, tipodocumento } = data;
      const params = { rut, folio, tipodocumento }
      const idToken = await getSession().then((session) => { return session.idToken.jwtToken });
      try {
        const resp = await consultaEstado(params, idToken);
        // setLoadingDetail(false);
        console.log(resp);
        var json = {
          "Descripcion": resp.descripcion,
          "Descripcion Error": resp.descripcionE,
          "Detalle": resp.detalle,
          "Fecha Recepción": resp.fecha_recepcion
        }
        console.log(json)
        setSiiData(json)
        // setdetailDocs(resp)

      } catch (error) {

      }

    }

    useEffect(() => {
      // loadDataOnlyOnce();
      respPorDocumento(data);
    }, [data]);


    // setLoadingDetail(false)
    console.log(data);
    let tieneData = (siiData != null);
    console.log(tieneData)
    return (tieneData ? <pre>{JSON.stringify(siiData, null, 2)}</pre> : <pre> <div className="ml-2"><h4>Cargando{loadingDetail && <Spinner animation="border" role="status" className='sticky-top'></Spinner>}</h4> </div> </pre>);
    // return <pre> <div className="ml-2"><h4>Cargando{loadingDetail && <Spinner animation="border" role="status" className='sticky-top'></Spinner>}</h4> </div> </pre>
  }


  // useEffect(() => {
  //   console.log('datadetaaaaail')
  //   console.log(loadingDetail);
  //   // setLoadingDetail(false);
  // }, [detailDocs])
  // useEffect(()=> {
  //   console.log('useefeeeect')
  // },[ExpandedComponent]); 

  const columnsDetallesDoc = [
    {
      name: 'Folio',
      selector: row => row.folio,
      sortable: true,
      width: '8%',
    },
    {
      name: 'Device_id',
      selector: row => row.device_id,
      sortable: true,
      width: '27%'
    },
    {
      name: 'RUT',
      selector: row => row.rut,
      sortable: true,
    },
    {
      name: 'Fecha',
      selector: row => row.fechaemision,
      sortable: true,
      width: '10%'
    },
    {
      name: 'Tipo Documento',
      selector: row => row.tipodocumento,
      // cell: (row) => <div style={{ width: '18rem', cursor: 'pointer' }} onClick={() => { handleButtonClick(row) }}>{row.documentos_no_autorizados}</div>,
      sortable: true,
      width: '12%'

    },
    {
      name: 'Valor Total',
      selector: row => row.valortotal,
      sortable: true,
      width: '10%'
    },
    {
      name: 'Valor Neto',
      selector: row => row.valorneto,
      sortable: true,
      width: '10%'
    },
    {
      name: 'Valor I.V.A',
      selector: row => row.valoriva,
      sortable: true,
      width: '10%'
    },
    // {

    //   cell: (row) => <Button color="secondary" onClick={() => { Reenvio(row) }} >Reenviar</Button>,
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    //   width: '12%'
    // },
  ];
  const paginationOpciones = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsText: 'Todos'
  }

  const Reenvio = async (params) => {
    console.log(params);
    setDetailShow(false);
    setmodalTitle('');
    setMessage('Reenviando documentos');
    setLoading(true);
    setShow(true);
    const idToken = await getSession().then((session) => { return session.idToken.jwtToken });
    console.log('token', idToken);
    try {
      const resp = await reenvioDocs(params, idToken);

      console.log(resp);

      setLoading(false);
      setmodalTitle('')
      setMessage('Documentos Reenviados');




    } catch (error) {

    }

  }

  const handleCheckTable = ({ selectedRows }) => {
    // You can set state or dispatch with something like Redux so we can use the retrieved data
    // console.log('Selected Rows: ', selectedRows);
    setSelectedRows(selectedRows)
  };

  const handleReenviarSeleccionados = async () => {
    if (!selectedRows || selectedRows.length === 0) return;
    const selectedList = selectedRows.map((element) => ({
      folio: element.folio,
      fechaemision: element.fechaemision,
      tipodocumento: element.tipodocumento,
    }));
    const rut = selectedRows[0].rut;
    await Reenvio({ rut, selectedList });
  };

  const opcionesTipoDocumento = [
    { value: "", label: "Todos" },
    { value: "39", label: "Boleta Electrónica" },
    { value: "41", label: "Boleta Exenta Electrónica" },
    { value: "33", label: "Factura Electrónica" }
  ];

  const limpiarFiltros = () => {
    setTipodocumento("");
    setStartDate("");
    setEndDate("");
  };

  return (
    <>
      <Container fluid className="page-container">
        <div className="page-header">
          <div>
            <h2 className="page-title">Resumen Estado Docs</h2>
            <p className="page-subtitle">
              Consulta el estado consolidado de documentos por empresa en un rango de fechas.
            </p>
          </div>
        </div>

        <Card className="data-card">
          <Card.Body>
            <Form onSubmit={busqueda} className="filter-form">
              <Row>
                <Col sm={12} md={4}>
                  <Form.Group className="form-field">
                    <Form.Label>Tipo documento</Form.Label>
                    <Select
                      options={opcionesTipoDocumento}
                      value={opcionesTipoDocumento.find((o) => o.value === tipodocumento) || null}
                      onChange={(opt) => setTipodocumento(opt ? opt.value : '')}
                      isSearchable={false}
                      classNamePrefix="rs"
                    />
                  </Form.Group>
                </Col>
                <Col sm={6} md={3}>
                  <Form.Group className="form-field">
                    <Form.Label>Desde</Form.Label>
                    <FormControl type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                  </Form.Group>
                </Col>
                <Col sm={6} md={3}>
                  <Form.Group className="form-field">
                    <Form.Label>Hasta</Form.Label>
                    <FormControl type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                  </Form.Group>
                </Col>
                <Col sm={12} md={2} className="d-flex align-items-end form-actions">
                  <Button type="submit" className="btn-primary-action">
                    <i className="nc-icon nc-zoom-split" />
                    Buscar
                  </Button>
                </Col>
              </Row>
              <div className="filter-form__footer">
                <Button className="btn-link-clear" onClick={limpiarFiltros}>
                  Limpiar filtros
                </Button>
                {dataFiltered != null && (
                  <label className="check-inline">
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={(e) => setChecked(e.currentTarget.checked)}
                    />
                    <span>Mostrar solo con errores</span>
                  </label>
                )}
              </div>
            </Form>
          </Card.Body>
        </Card>

        {stats && (
          <Row className="stats-row">
            <Col xs={12} sm={6} lg={3}>
              <div className="stat-card stat-card--danger">
                <div className="stat-card__icon"><i className="nc-icon nc-simple-remove" /></div>
                <div className="stat-card__content">
                  <span className="stat-card__label">Total con problemas</span>
                  <span className="stat-card__value">{stats.problemas}</span>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="stat-card stat-card--danger">
                <div className="stat-card__icon"><i className="nc-icon nc-lock-circle-open" /></div>
                <div className="stat-card__content">
                  <span className="stat-card__label">No autorizados</span>
                  <span className="stat-card__value">{stats.noAutorizados}</span>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="stat-card stat-card--warning">
                <div className="stat-card__icon"><i className="nc-icon nc-cloud-upload-94" /></div>
                <div className="stat-card__content">
                  <span className="stat-card__label">No recibidos / enviados</span>
                  <span className="stat-card__value">{stats.noRecibidosOEnviados}</span>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="stat-card stat-card--warning">
                <div className="stat-card__icon"><i className="nc-icon nc-alert-circle-i" /></div>
                <div className="stat-card__content">
                  <span className="stat-card__label">Con errores</span>
                  <span className="stat-card__value">{stats.conErrores}</span>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {dataFiltered != null && (
          <Card className="data-card">
            <Card.Body>
              <div className="data-card__toolbar">
                <div className="search-input">
                  <i className="nc-icon nc-zoom-split" />
                  <input
                    type="text"
                    name="search"
                    value={filter}
                    autoComplete="off"
                    placeholder="Filtrar por empresa..."
                    onChange={handleChange}
                  />
                </div>
                <Button className="btn-export" onClick={() => downloadCSV(dataFiltered)}>
                  <i className="nc-icon nc-cloud-download-93" />
                  Exportar CSV
                </Button>
              </div>
              <DataTable
                className="-striped -highlight"
                fixedHeader={true}
                columns={columns}
                data={dataFiltered}
                pagination
                paginationComponentOptions={paginationOpciones}
              />
            </Card.Body>
          </Card>
        )}

        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="result-loading">
              {loading && <Spinner animation="border" role="status" />}
              <span>{Message}</span>
            </div>
          </Modal.Body>
          {!loading && (
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>Cerrar</Button>
            </Modal.Footer>
          )}
        </Modal>

        <Modal show={detailShow} onHide={handleCloseDetail} size="xl" scrollable centered>
          <Modal.Header closeButton>
            <Modal.Title>Detalle Documentos</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card className="data-card">
              <Card.Body>
                <div className="data-card__toolbar">
                  <span className="toolbar-meta">
                    {detailData ? `${detailData.length} documento${detailData.length === 1 ? '' : 's'}` : ''}
                    {selectedRows && selectedRows.length > 0 && (
                      <span className="toolbar-meta__selected">
                        · {selectedRows.length} seleccionado{selectedRows.length === 1 ? '' : 's'}
                      </span>
                    )}
                  </span>
                  <div className="toolbar-actions">
                    {selectedRows && selectedRows.length > 0 && (
                      <Button className="btn-primary-action btn-reenviar" onClick={handleReenviarSeleccionados}>
                        <i className="nc-icon nc-send" />
                        Reenviar seleccionados
                      </Button>
                    )}
                    <Button className="btn-export" onClick={() => downloadCSV(detailData)}>
                      <i className="nc-icon nc-cloud-download-93" />
                      Exportar CSV
                    </Button>
                  </div>
                </div>
                {detailData != null && (
                  <DataTable
                    className="-striped -highlight"
                    fixedHeader={true}
                    columns={columnsDetallesDoc}
                    data={detailData}
                    pagination
                    expandableRows={true}
                    expandOnRowClicked={true}
                    selectableRows
                    onSelectedRowsChange={handleCheckTable}
                    expandableRowsComponent={ExpandedComponent}
                    paginationComponentOptions={paginationOpciones}
                  />
                )}
              </Card.Body>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDetail}>Cerrar</Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
}

export default EstadoResumen;
